"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;

function scrollTo(ref, offset) {
  ref.current.scrollTo(0, offset);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/InternalDropdown/helpers/scrollTo.js
// module id = 8x58
// module chunks = 0